import { Form230Input } from "../dtos/form230/input";
import Server from "./index";

export default class Form230Server extends Server {
  constructor() {
    super("/form230.php");
  }

  public post(data: Form230Input): Promise<any> {
    return super.post(data);
  }
}
